import React from 'react';
import moment from 'moment';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  padding: 0 1.5rem;
`;

const IntervalInfo = (props) => {
  const { fromInTimezone, toInTimezone, timeslot } = props;
  return (
    <Wrapper>
      {fromInTimezone && toInTimezone && (
        <>
          <h5>Желаемый интервал</h5>
          <p>
            {moment.utc(fromInTimezone).format('YYYY-MM-DD HH:mm')} -{' '}
            {moment.utc(toInTimezone).format('YYYY-MM-DD HH:mm')}
          </p>
        </>
      )}

      <h5>Установленный в OZON интервал</h5>
      {timeslot?.from && timeslot?.to ? (
        <p>
          {moment.utc(timeslot.from).format('YYYY-MM-DD HH:mm')} -{' '}
          {moment.utc(timeslot.to).format('YYYY-MM-DD HH:mm')}
        </p>
      ) : (
        <span>Неизвестно</span>
      )}
    </Wrapper>
  );
};

export default IntervalInfo;
